import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./globals.css";
import { initClientObservability } from "./lib/observability";
import { registerServiceWorker } from "./lib/service-worker";

initClientObservability();
registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <App />
);
